import { useTranslation } from 'react-i18next';
import { withStyles } from 'vopay';
import { MaterialSymbol } from 'UI';
import { RichCopy } from '../types';
import styles from './IntegrationSteps.module.scss';

const cn = withStyles(styles);

type IntegrationStepsProps = {
  steps: RichCopy[];
};

/** The Figma stepper: a green check indicator per step, joined by a connector line */
export default function IntegrationSteps({ steps }: IntegrationStepsProps) {
  // Catalogue copy resolves against a root t with full keys (see ../types.ts)
  const { t: tRoot } = useTranslation();

  return (
    <ol className={cn('steps')}>
      {steps.map((step, index) => (
        <li key={index} className={cn('step')}>
          <span className={cn('indicator')}>
            <MaterialSymbol icon="check_circle" size="14px" className={cn('checkIcon')} />
          </span>

          <span className={cn('stepText')}>{step(tRoot)}</span>
        </li>
      ))}
    </ol>
  );
}
